import styled, { BaseThemedCssFunction, DefaultTheme } from 'styled-components';
import { forDesktop } from '@westwing/ui-kit/breakPoints';

const CartFlyoutContainer = styled.div<{ $isVisible: boolean }>`
    display: none;
    position: absolute;
    right: 8px;
    top: 60px;
    background: white;
    width: 264px;
    border: 1px solid ${({ theme }) => theme.colors.charcoal20};

    &::before {
        content: '';
        width: 14px;
        height: 14px;
        display: block;
        background: white;
        border: 1px solid ${({ theme }) => theme.colors.charcoal20};
        transform: rotate(45deg);
        position: absolute;
        top: -9px;
        right: 7px;
        border-bottom: none;
        border-right: none;
    }

    &::after {
        content: '';
        width: 100%;
        height: 25px;
        display: block;
        position: absolute;
        top: -25px;
        left: 0;
    }

    ${(forDesktop as BaseThemedCssFunction<DefaultTheme>)<{ $isVisible: boolean }>`
        ${({ $isVisible }) => $isVisible && 'display: block;'};
        &:hover {
            display: block;
        }
    `}
`;

export default CartFlyoutContainer;
